import { prefetchPartnersProfileRetrieveQuery } from "@boundless/bl-api-client/partners/services"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { NoPermissionComponent } from "@/components/error/NoPermissionComponent"
import { useHasPermissions } from "@/components/users/hooks/useHasPermissions"

export const Route = createFileRoute("/_dashboard/partners")({
  beforeLoad: ({ context: { store } }) => {
    const { userRole } = store.getState()
    const roleNotLenderOrPartner =
      userRole !== "partner" && userRole !== "lender"
    if (roleNotLenderOrPartner) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await prefetchPartnersProfileRetrieveQuery(queryClient)
  },
  component: RouteComponent,
})

function RouteComponent() {
  // Permission is checked here (rendered) rather than in `beforeLoad`
  // (redirected) on purpose: `/` redirects partner/lender roles back to
  // `/partners`, so redirecting on missing permission would form an infinite
  // loop. Rendering instead breaks the cycle. `useHasPermissions` reacts to
  // permissions loading (unlike the store's stable `hasPermissions` method).
  const canViewPartner = useHasPermissions(["partners.view_partner"])
  if (!canViewPartner) {
    return <NoPermissionComponent />
  }
  return <Outlet />
}
